/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropentrystateclaimed3Inputs */

const en_dropentrystateclaimed3 = /** @type {(inputs: Dropentrystateclaimed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimed`)
};

const de_dropentrystateclaimed3 = /** @type {(inputs: Dropentrystateclaimed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingelöst`)
};

/**
* | output |
* | --- |
* | "Claimed" |
*
* @param {Dropentrystateclaimed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropentrystateclaimed3 = /** @type {((inputs?: Dropentrystateclaimed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropentrystateclaimed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropentrystateclaimed3(inputs)
	return de_dropentrystateclaimed3(inputs)
});
export { dropentrystateclaimed3 as "dropEntryStateClaimed" }